import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
export const MyTextField = (props) => {
  const [value, setValue] = useState(props.value);

  const handleChange = (value) => {
    let isValid = true;
    if (props.regExp) {
      let regEx = new RegExp(props.regExp);
      isValid = regEx.test(value);
    }
    if (props.min) {
      if (Number(value) < Number(props.min)) {
        isValid = false;
      }
    }
    if (props.max) {
      if (Number(value) > Number(props.max)) {
        isValid = false;
      }
    }
    if (props.maxLength) {
      if (value && value.length > props.maxLength) {
        isValid = false;
      }
    }
    if (isValid) {
      setValue(value);
      props.onChange(value);
    }
  };

  const inputMode = props.inputMode ? props.inputMode : "text";

  useEffect(() => {
    if (!props.value) setValue(props.value);
    else if (!!props.value && value !== props.value) setValue(props.value);
  }, [props.value]);

  return (
    <TextField
      id={props.id}
      disabled={props.disabled}
      autoComplete={props.autoComplete ?? "off"}
      name={props.name}
      className={props.className}
      size={props.size ? props.size : "medium"}
      style={{ width: "100%", margin: "1rem 0", ...props.style }}
      helperText={props.helperText}
      error={!!props.helperText}
      type={props.type}
      value={value}
      variant="outlined"
      label={props.label}
      onChange={(e) => handleChange(e.target.value)}
      placeholder={props.placeholder}
      onKeyPress={props.onKeyPress}
      required={props.required}
      multiline={props.multiline}
      rows={props.rows}
      slotProps={{
        inputLabel: props.inputLabelStyles,
      }}
      sx={{
          ...props.sx
      }}
      inputProps={{
        maxLength: props.maxLength,
        inputMode: inputMode,
      }}
    />
  );
};
